import { config } from "./libs/config"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { useEffect, useReducer, createContext } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { get } from "./libs/helper"
import { Home } from "./components/pages/Home"
import { AccountingReconciliation } from "./components/pages/reports/AccountingReconciliation"
import { OpayoReconciliation } from "./components/pages/reports/OpayoReconciliation"
import { PerformanceAnalysis } from "./components/pages/reports/PerformanceAnalysis"
import { Acturis } from "./components/pages/Acturis"
import { Customers } from "./components/pages/reports/Customers"
import { Tickets } from "./components/pages/reports/Tickets"
import { Incomplete } from "./components/pages/Incomplete"
import { View } from "./components/pages/View"
import { Login } from "./components/pages/Login"
import { Users } from "./components/pages/management/Users"
import { ResetPassword } from "./components/pages/ResetPassword"
import { Error } from "./components/pages/Error"
import dayjs from "dayjs"

const env = window.location.hostname.includes("stage") || window.location.hostname.includes("local") ? 'stage' : 'prod'

export const MyContext = createContext()

export default function App() {

      const [AppData, setAppData] = useReducer((oldData, newItem) => { return ({ ...oldData, ...newItem }) }, { version: "ch@rl3s v55", status: "", ...config[env] })
      const [UserData, setUserData] = useReducer((oldData, newItem) => { return ({ ...oldData, ...newItem }) }, { loggedIn: false })

      // Logs AppData changes
      useEffect(() => {
            // console.log(`AppData ${dayjs().format("HH:mm:ss.SSS")}`, JSON.stringify(AppData))
      }, [AppData])

      // Logs UserData changes
      useEffect(() => {
            // console.log(`UserData ${dayjs().format("HH:mm:ss.SSS")}`, JSON.stringify(UserData))
      }, [UserData])

      useEffect(() => {
            const storedUser = sessionStorage.getItem("dasher_user")
            const storedToken = sessionStorage.getItem("dasher_token")

            if (storedUser && storedToken && !UserData.loggedIn) {
                  try {
                        const parsedUser = JSON.parse(storedUser)
                        setUserData({ ...parsedUser, loggedIn: true })
                  } catch (e) {
                        sessionStorage.removeItem("dasher_user")
                        sessionStorage.removeItem("dasher_token")
                  }
            }
      }, [UserData.loggedIn])

      // Login sets users + config; after a full page reload only sessionStorage is restored — re-fetch so View and lookups work.
      useEffect(() => {
            if (!UserData.loggedIn) return
            if ("users" in AppData) return
            if (!sessionStorage.getItem("dasher_token")) return

            let cancelled = false
            const apiSlice = { api: config[env].api }

                  ; (async () => {
                        try {
                              const usersParams = {
                                    brand: "dasher",
                                    table: "users",
                                    query: { select: "id,first_name, last_name" }
                              }
                              const { result: users } = await get(usersParams, apiSlice)

                              const configQuery = {
                                    brand: "dasher",
                                    table: "config",
                                    query: { select: "acturis_maint_window_start, acturis_maint_window_end" }
                              }
                              const { result: configResult } = await get(configQuery, apiSlice)

                              if (!cancelled) {
                                    setAppData({
                                          users: users ?? [],
                                          config: configResult?.[0]
                                    })
                              }
                        } catch (e) {
                              console.error("Session restore: failed to load users/config", e)
                              if (!cancelled) {
                                    setAppData({ users: [], config: null })
                              }
                        }
                  })()

            return () => {
                  cancelled = true
            }
      }, [UserData.loggedIn, AppData])

      if (UserData.loggedIn) {

            return (

                  <ErrorBoundary
                        FallbackComponent={Error}
                        onError={(error, info) => {
                              console.error("React error boundary:", error)
                              console.error(info.componentStack)
                        }}
                  >
                        <MyContext.Provider value={{ AppData, setAppData, UserData, setUserData }}>
                              <Router>
                                    <Routes>
                                          <Route path="/" element={<Home />} />
                                          <Route path="/reports/accounting/reconciliation" element={<AccountingReconciliation />} />
                                          <Route path="/reports/accounting/opayo" element={<OpayoReconciliation />} />
                                          <Route path="/reports/sales/performance-analysis" element={<PerformanceAnalysis />} />
                                          <Route path="/reports/acturis" element={<Acturis />} />
                                          <Route path="/reports/customers" element={<Customers />} />
                                          <Route path="/reports/tickets" element={<Tickets />} />
                                          <Route path="/management/users" element={<Users />} />
                                          <Route path="/reports/customers/incomplete" element={<Incomplete />} />
                                          <Route path="/customer/view" element={<View />} />
                                          <Route path="/*" element={<Error />} />
                                    </Routes>
                              </Router>
                        </MyContext.Provider>
                  </ErrorBoundary>
            )

      } else {

            return (
                  <MyContext.Provider value={{ AppData, setAppData, setUserData }}>
                        <Router>
                              <Routes>
                                    <Route path="/reset-password" element={<ResetPassword />} />
                                    <Route path="*" element={<Login />} />
                              </Routes>
                        </Router>
                  </MyContext.Provider>
            )

      }

}
